import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../../assets/images/logo3.png';

const Footer = () => {
    return (
        <footer className="footer-container">
            <div className="footer-content">
                <div className="footer-grid">
                    <div className="footer-column">
                        <img
                            src={logo}
                            alt="Abonelik Hizmetleri"
                            className="footer-logo"
                            loading="lazy"
                        />
                        <p className='info-text'>
                            Türkiye’deki internet ve TV hizmetlerini tek bir çatı altında toplayarak karşılaştırmalı şekilde sunan, avantajlı kampanyaları keşfetmenizi sağlayan platformdur.
                        </p>
                    </div>

                    <div className="footer-column">
                        <h3 className="footer-heading">Kurumsal Linkler</h3>
                        <ul className="footer-links">
                            <li><Link to="/kampanyalar" className="footer-link">İnternet Paketleri</Link></li>
                            <li><Link to="/kampanyalar" className="footer-link">Fiber İnternet</Link></li>
                            <li><Link to="/iletisim" className="footer-link">Bize Ulaşın</Link></li>
                            <li><Link to="/kvkk" className="footer-link">KVKK Aydınlatma Metni</Link></li>
                            <li><Link to="/cerez-politikasi" className="footer-link">Çerez Politikası</Link></li>
                        </ul>
                    </div>

                    <div className="footer-column">
                        <h3 className="footer-heading">İnternet Paketleri</h3>
                        <ul className="footer-links">
                            <li><Link to="/kampanyalar/OY24SVSne7XfijM7xYkz/YSXZOcKeEr272UByyP5p" className="footer-link">Türksat Kablonet Hoşgeldin Kampanyası 50Mbps</Link></li>
                            <li><Link to="/kampanyalar/cVWHs6j4KvAWNtfv3Ijv/h9o4b96TIQspDHgZy7dO" className="footer-link">Turkcell Superonline Fiber Hız Keyfi 50 Mbps</Link></li>
                            <li><Link to="/kampanyalar/e8YRGdq2XoAMPeWMY2Pq/QdOVaRFMLTnprjtE3Hhk" className="footer-link">Digiturk Taraftar Paketi (Kutusuz)</Link></li>
                            <li><Link to="/kampanyalar/GIuiDkrLsq1Wt6Zf2iTA/s0eTIWSOx3PgiL57n01o" className="footer-link">Vodafone Evde Fiber 200 Mbps Sınırsız</Link></li>
                        </ul>
                    </div>

                </div>

                <div className="footer-copyright">
                    <div className="copyright-content">
                        <p className="copyright-text">Powered by  © <a href="https://www.janberkaltay.dev/" target="_blank" rel="noopener noreferrer">Janberk ALTAY </a></p>
                        <p className="copyright-text">fiberinternetim.com.tr İnternet Satış Bayisidir | © {new Date().getFullYear()}</p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;